











import Vue from 'vue';
import { IFooterHeadlineLinks } from '../../../common/interfaces/footer.interface';
import FooterLink from './FooterLink.vue';

export default Vue.extend({
  name: `HelpAndContact`,
  components: { FooterLink },
  data(): IFooterHeadlineLinks {
    return {
      headline: window.vueFooter.helpAndContact.headline,
      links: window.vueFooter.helpAndContact.links,
    };
  },
});
